/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1ExamQuestionLibraryItemIdMutationRequest,
  PutApiV1ExamQuestionLibraryItemIdMutationResponse,
  PutApiV1ExamQuestionLibraryItemIdPathParams,
  PutApiV1ExamQuestionLibraryItemId400,
  PutApiV1ExamQuestionLibraryItemId401,
  PutApiV1ExamQuestionLibraryItemId404,
  PutApiV1ExamQuestionLibraryItemId500,
} from "../../types/examQuestionLibraryController/PutApiV1ExamQuestionLibraryItemId.ts";

function getPutApiV1ExamQuestionLibraryItemIdUrl(
  id: PutApiV1ExamQuestionLibraryItemIdPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/exam/question-library/item/${id}` as const,
  };
  return res;
}

/**
 * @description Atualiza os dados de uma questão existente na biblioteca de questões. O id da questão é passado pela rota. O tipo do componente determina quais campos são processados. Para questões de lista, as opções removidas são excluídas automaticamente. **(Requer Authorization para autenticação)**
 * @summary Editar questão na biblioteca (Requer Authorization para autenticação)
 * {@link /api/v1/exam/question-library/item/:id}
 */
export async function putApiV1ExamQuestionLibraryItemId(
  id: PutApiV1ExamQuestionLibraryItemIdPathParams["id"],
  data: PutApiV1ExamQuestionLibraryItemIdMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1ExamQuestionLibraryItemIdMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1ExamQuestionLibraryItemIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamQuestionLibraryItemId400
      | PutApiV1ExamQuestionLibraryItemId401
      | PutApiV1ExamQuestionLibraryItemId404
      | PutApiV1ExamQuestionLibraryItemId500
    >,
    PutApiV1ExamQuestionLibraryItemIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1ExamQuestionLibraryItemIdUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
